import type { RouteObject } from 'react-router-dom'

import { DashboardPage } from '@/features/assessment/management/pages/DashboardPage'
import { MainLayout } from '@/layouts'

export const dashboardRoutes: RouteObject = {
  path: 'dashboard',
  element: <MainLayout />,
  children: [
    {
      index: true,
      element: <DashboardPage />
    }
  ]
}
